const   products= [{
    id: 1,
    title: "vivo ",
    desc: "Vivo V29e 256 GB (Artistic Red, 8 GB RAM)",
    price: '29000',
    img: "vivo2.jpg",
    amount: 1,
  },
  {
    id: 2,
    title: "vivo",
    desc: "VIVO T1 44W STARRY SKY 128 GB 4 GB RAM",
    price: 15_473,
    img: "vivo3.jpg",
    amount: 1,
  },
  {
    id: 3,
    title: "vivo",
    desc: "Vivo X80 5G V2183A Dual Sim 128GB Orange (8GB RAM) - China Version",
    price: 58878,
    img: "vivo4.jpg",
    amount: 1,
  },
  {
    id: 4,
    title: "vivo",
    desc: "VIVO T1 44W STARRY SKY 128 GB 4 GB RAM",
    price: 15500,
    img: "vivo5.jpg",
    amount: 1,
  },
  ,
  {
    id: 6,
    title: "Infinix",
    desc: "Infinix HOT 12 Play (Daylight Green, 4GB RAM 64GB Storage)",
    price: 9000,
    img: "vivo7.jpg",
    amount: 1,
  },
  {
    id: 7,
    title: "OnePlus",
    desc: "OnePlus Nord CE 3 Lite 5G (Chromatic Gray, 8GB RAM, 128GB Storage)",
    price: 19990,
    img: "oneplus.jpg",
    amount: 1,
  },
  {
    id: 8,
    title: "Oneplus",
    desc: "OnePlus Nord 3 5G (Misty Green, 8GB RAM, 128GB Storage)",
    price: 33999,
    img: "oneplus1.jpg",
    amount: 1,
  },
  {
    id: 9,
    title: "vivo",
    desc: "Vivo Y12 64 GB (Aqua Blue, 3 GB RAM)",
    price: 13000,
    img: "vivo9.jpg",
    amount: 1,
  },
  {
    id: 10,
    title: "Samsung",
    desc: "Samsung Galaxy A54 5G (Awesome Violet, 8GB, 256GB Storage) | 50 MP No Shake Cam (OIS) | IP67 | Gorilla Glass 5  | Without Charger",
    price: 33999,
    img: "galaxy.jpg",
    amount: 1,
  },
  {
    id: 11,
    title: "Lava",
    desc: "Lava Blaze 5G (Glass Blue, 6GB RAM, UFS 2.2 128GB Storage) | 5G Ready | 50MP AI Triple Camera ",
    price: 34000,
    img:"lava.jpg",
    amount: 1,
  },
  {
    id: 12,
    title: "oppo",
    desc: "OPPO Reno8T 5G 8GB 128GB Sunrise Gold smart-phones ( 8 GB 128 GB )",
    price: 24500,
    img: "oppo.jpg",
    amount: 1,
  },
];

 export default products